import { render } from "./Locations.vue?vue&type=template&id=2d83831f&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2d83831f"

export default script